import { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { TentativeScoringQuestionContext } from '../context/TentativeScoringQuestionContext'
import { tentativeScoringQuestionListDefaultValues } from '../modules/tentativeScoringTest.module'
import { TentativeScoringQuestionListFormType } from '../types/tentativeScoringQuestionListForm.type'

const useTentativeScoringQuestionListForm = () => {
  const { examGradingQuestionData } = useContext(
    TentativeScoringQuestionContext,
  )

  const formMethods = useForm<TentativeScoringQuestionListFormType>({
    mode: 'onSubmit',
    defaultValues: async () => {
      if (examGradingQuestionData) {
        const { math, reasoning } = examGradingQuestionData
        const mathDataList = {
          math: {
            inputQuestions: tentativeScoringQuestionListDefaultValues(math),
          },
        }
        const reasoningDataList = {
          reasoning: {
            inputQuestions:
              tentativeScoringQuestionListDefaultValues(reasoning),
          },
        }

        return {
          ...mathDataList,
          ...reasoningDataList,
        }
      } else {
        return {
          math: {
            inputQuestions: [],
          },
          reasoning: {
            inputQuestions: [],
          },
        }
      }
    },
  })

  return formMethods
}

export default useTentativeScoringQuestionListForm
